import { render, staticRenderFns } from "./BlockoutDaysDocument.vue?vue&type=template&id=5620dcc5&scoped=true&"
import script from "./BlockoutDaysDocument.vue?vue&type=script&lang=js&"
export * from "./BlockoutDaysDocument.vue?vue&type=script&lang=js&"
import style0 from "./BlockoutDaysDocument.vue?vue&type=style&index=0&id=5620dcc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620dcc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5620dcc5')) {
      api.createRecord('5620dcc5', component.options)
    } else {
      api.reload('5620dcc5', component.options)
    }
    module.hot.accept("./BlockoutDaysDocument.vue?vue&type=template&id=5620dcc5&scoped=true&", function () {
      api.rerender('5620dcc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/BlockoutDaysDocument.vue"
export default component.exports